module.exports = __webpack_public_path__ + "img/eagleEye2_1.a41cdee2.png";